<template>
  <div :style="cardStyle()" class="card">
    <div class="row">
      <div v-show="show.thumbnail" class="col-sm-5">
        <img :style="thumbnailStyle()" :src="article.thumbnail" alt="">
      </div>
      <div class="col-sm-7">
        <div class="card-block">
          <!--           <h4 class="card-title">Small card</h4> -->
          <p>{{ article.title }}</p>
          <p v-show="show.author">{{ article.author.name }}</p>
          <br>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ['article', 'config', 'colors', 'show', 'styles', 'sizes'],
  name: 'Teste',
  methods: {
    cardStyle() {
      return `background-color: ${this.colors.color_1};
              height: ${this.sizes.card.height !== '0px' ? this.sizes.card.height : 'auto'};
               border-radius: ${this.sizes.card.borderRadius};`;
    },
    thumbnailStyle() {
      return `height: ${this.sizes.thumbnail.height !== '0px' ? this.sizes.thumbnail.height : 'auto'};
              width: ${this.sizes.thumbnail.width !== '0px' ? this.sizes.thumbnail.width : '100%'};
              border-radius: ${this.sizes.thumbnail.borderRadius};`;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Lists/Article/cards/Teste.vue